export default __webpack_public_path__ + "cf52cbd69871835ac3b8dbc260ac8a6d.png";